import axios from 'axios'
import {
  getCsrfToken,
  getSessionToken,
} from '@futures-platform/connectors/session'

const baseUrl = process.env.REACT_APP_SCENARIO_API_URL
const publicURL = process.env.REACT_APP_PUBLIC_URL
const searchURL = process.env.REACT_APP_SEARCH_API_URL
const contentServiceURL = process.env.REACT_APP_CONTENT_SERVICE_API_URL
const mediaURL = process.env.REACT_APP_MEDIA_API_URL
const SPOTLIGHT_API_URL = process.env.REACT_APP_SPOTLIGHT_SERVICE_API_URL
const votingURL = process.env.REACT_APP_VOTING_BASE_URL_API
const DRUPAL_API_URL = process.env.REACT_APP_DRUPAL_API_URL

async function httpRequest(
  baseUrlParams,
  method,
  path,
  payload = null,
  headers = {},
) {
  return axios({
    method,
    url: `${baseUrlParams}/${path}`,
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSessionToken()}`,
      ...headers,
    },
    withCredentials: true,
    data: payload || null,
  })
}

async function httpRequestNoAuth(
  baseUrlParams,
  method,
  path,
  payload = null,
  headers = {},
) {
  return axios({
    method,
    url: `${baseUrlParams}/${path}`,
    headers: {
      // 'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
      // Authorization: `No Auth`,
      // ...headers,
    },
    // withCredentials: true,
    data: payload || null,
  })
}
export const spotlightAPIs = {
  // getSpotLight: async (payload) => {
  //   return await httpRequest(SPOTLIGHT_API_URL, 'POST', `spotlight`, payload)
  // },
  getSpotLight: async (type = 'news', newsId, payload) => {
    const domainUrl = 'https://' + window.location.hostname

    let extraUrl = ''
    switch (type) {
      case 'news':
        extraUrl = 'news-item'

        // url = '/recommendation-service-api/content_to_content'
        break
      case 'phenomenon':
        extraUrl = 'phenomenon'
        break
      case 'scenario':
        extraUrl = 'scenario-card'
        break
      default:
        extraUrl = 'news-item'

        break
    }
    return await httpRequest(
      // SPOTLIGHT_API_URL,
      domainUrl + '/recommendation-service-api/content_to_content',
      'POST',
      `spotlight/${extraUrl}/${newsId}`,
      payload,
    )
  },
  // getSpotLightByTagNames: async (payload) => {
  //   return await httpRequest(
  //     SPOTLIGHT_API_URL,
  //     'POST',
  //     `spotlight/tagNames`,
  //     payload,
  //   )
  // },

  ////////////////
  getStatus1BookmarkNews: async (entityUri) => {
    return await httpRequest(
      votingURL,
      'GET',
      `bookmark/entityUri/${entityUri}`,
    )
  },
  getPhenomenaTypesGroup0: async () => {
    return await httpRequestNoAuth(
      DRUPAL_API_URL,
      'GET',
      'v1.0/phenomenontypes?sort=weight',
    )
  },

  addBookmarkNews: async (payload) => {
    return await httpRequest(votingURL, 'POST', `bookmark`, payload)
  },
  deleteBookmarkNews: async (entityUri) => {
    return await httpRequest(votingURL, 'DELETE', `bookmark/${entityUri}`)
  },
}
